import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { IconCheck, IconHome } from '@tabler/icons-react';
import { Card } from '../components/ui/card';

const SuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background bg-noise flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="w-full max-w-2xl"
        data-testid="success-page"
      >
        <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-8 sm:p-12 text-center">
          {/* Success Icon */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
            className="inline-flex items-center justify-center w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-green-500/10 mb-6"
            data-testid="success-icon"
          >
            <IconCheck size={64} className="text-green-500" stroke={2} />
          </motion.div>

          {/* Title */}
          <h1 className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl mb-4" data-testid="success-title">
            Оплата прошла успешно!
          </h1>

          {/* Description */}
          <p className="text-base sm:text-lg text-[color:hsl(var(--foreground))]/70 mb-6">
            Спасибо за оплату! Ваша запись подтверждена.
          </p>

          {/* Order Details */}
          {orderId && (
            <div className="bg-[color:hsl(var(--brand-orange))]/10 rounded-[64px] p-4 mb-8">
              <p className="text-sm text-[color:hsl(var(--foreground))]/60">Номер заказа</p>
              <p className="font-mono text-lg text-[color:hsl(var(--brand-orange))] mt-1" data-testid="order-id">
                {orderId}
              </p>
            </div>
          )}

          {/* Info Message */}
          <p className="text-sm text-[color:hsl(var(--foreground))]/60 mb-8">
            Ваша оплата подтверждена.<br />
            Ждем вас в салоне РИО!
          </p>

          {/* Back Button */}
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center justify-center h-14 px-10 rounded-[128px] bg-[color:hsl(var(--brand-orange))] text-white text-lg font-medium transition-[background-color,transform] duration-200 ease-out hover:bg-[color:hsl(var(--brand-orange-700))] hover:scale-105 shadow-lg"
            data-testid="back-home-button"
          >
            <IconHome size={20} className="mr-2" />
            Вернуться на главную
          </button>
        </Card>
      </motion.div>
    </div>
  );
};

export default SuccessPage;
